import { render, staticRenderFns } from "./propertyDscription.vue?vue&type=template&id=29c6378e&scoped=true&"
import script from "./propertyDscription.vue?vue&type=script&lang=js&"
export * from "./propertyDscription.vue?vue&type=script&lang=js&"
import style0 from "./propertyDscription.vue?vue&type=style&index=0&id=29c6378e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c6378e",
  null
  
)

export default component.exports